export const defaultValue = {
    id: '',
    action: '',
    description: '',
    active: true,
    createdBy: '',
    createdDate: null,
    lastModifiedBy: '',
    lastModifiedDate: null,
};
